import React, { useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap"; // Assuming you're using React Bootstrap

const ModalDialogue = ({ isModalDialogueOpen, question, onModalDialogueResponse, goBackText = "No, Go back", goText = "Yes, delete it!" }) => {
   const modalRef = useRef(null);

   const handleClose = (response) => {
      onModalDialogueResponse(response);
   };

   return (
      <>
         {isModalDialogueOpen && (
            <Modal
               centered={true}
               backdrop="static"
               ref={modalRef}
               show={isModalDialogueOpen}
               onHide={handleClose}
               animation={false}
               style={{ zIndex: 1050 }}>
               <Modal.Header closeButton>
                  <Modal.Title>Confirmation</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  <p>{question}</p>
               </Modal.Body>
               <Modal.Footer>
                  <Button
                     variant="secondary"
                     onClick={() => handleClose("go_back")}>
                     {goBackText}
                  </Button>
                  <Button
                     variant="primary"
                     onClick={() => handleClose("go")}>
                     {goText}
                  </Button>
               </Modal.Footer>
            </Modal>
         )}
      </>
   );
};

export default ModalDialogue;
